import { Page } from "@/ui/Layout";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "@/AppContext";
import { CopilotWrapper } from "./CopilotWrapper";

export const Copilot = ({ name = "Copilot", sessionReplay = false }) => {
  const [campaignName, setCampaignName] = useState();
  const { id } = useParams();
  const [campaignId, setCampaignId] = useState(id);
  const [topBarButtons, setTopBarButtons] = useState(null);
  const {
    setCopilotOpen,
    copilotOpen,
    copilotSettings = {},
  } = useContext(AppContext);

  // const [copilotCampaignId, setCopilotCampaignId] = useState(copilotSettings?.id);
  // const [copilotCampaignName, setCopilotCampaignName] = useState(copilotSettings?.name);

  // useEffect(() => {
  //   setCopilotOpen(true);
  // }, []);

  useEffect(() => {
  //   // if (id) {
  //   console.log("Copilot.tsx", "setting campaign id", id);
    setCampaignId(id);
    // }
  }, [id]);

  return (
    <Page
      topBar={{
        showLeftSidebarToggle: true,
        page: [
          { label: `Launch Copilot`, href: "/copilot" },
          ...(campaignId
            ? [{ label: campaignName, href: `/copilot/${campaignId}` }]
            : []),
        ],
        items: topBarButtons,
        hideCopilotButton: true,
        hideTopbar: true,
      }}
      // copilotSettings={{ id: campaignId, setCampaignId, setCampaignName, setTopBarButtons }}
    >
      <CopilotWrapper
        id={campaignId}
        setCampaignId={setCampaignId}
        setCampaignName={setCampaignName}
        sessionReplay={sessionReplay}
        {...copilotSettings}
      />
    </Page>
  );
};
